<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{$t('apiDoc.在线文档')}}</span>
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >{{$t('apiDoc.测试工具')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";


import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'trace/subscribe';
export default {
name:"subscribe",
  components: { onlineDoc , apiTestDoc },
  data() { 
    return {    
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.trackDescription_2')}`,
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[
            
        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`,},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`,},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳，毫秒')}`,},
                    ]
            },
             { 
                title:`${this.$t('onlineDoc.请求参数')}`, 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: `${this.$t('onlineDoc.业务参数')}`,describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`,},
                ]
            },
             {
              title:`${this.$t('onlineDoc.业务参数')}`,
              value:[
                {name: "Id",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`},
                {name: "list",type: "Object ",require: "Y",normal: "",describe: `${this.$t('onlineDoc.数组')}`},
                {name: "traceNode",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.订阅节点')}`},
                {name: "waybillCode",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.极兔运单编号')}`}
              ]
            }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[
            
        //   响应参数
            {
                title:`${this.$t('onlineDoc.响应参数')}`,
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码，见附录')}`},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.业务数据')}`},
                  ]
            }
        ],
        //请求示例
        requestCode: `header
apiAccount  1001
digest   AQOx0zELeEPNK6blBabiNg==
timestamp   1590808798146

bizContent={
	"id": "1001",
	"list": [{
		"traceNode": "1&2&3&4&5&6&7&8&9&10&11",
		"waybillCode": "JT4000096429493"
	}]
}`,
        //返回示例
        responseCode: {"code":"1","msg":"success",data:"SUCCESS"} ,

       //错误代码提示
        errcodeJson: [{code:'145013501',msg:`${this.$t('apiTestDoc.运单号个数超过1000')}`},
          {code:'145003100',msg:`${this.$t('apiTestDoc.运单号非法')}`}]
      },


      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{"id":"1001","list":[{"traceNode":"1&2&3&4&5&6&7&8&9&10&11","waybillCode":"JT4000096429493"}]}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/trace/subscribe`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/trace/subscribe`,
       //错误代码提示
        errcodeJson: [{code:'145013501',msg:`${this.$t('apiTestDoc.运单号个数超过1000')}`},
          {code:'145003100',msg:`${this.$t('apiTestDoc.运单号非法')}`}]
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>